import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import apiUrl from '../../../../../constants';
import awsBucketName from '../../../../../constants';
import axios from 'axios';
import {getDatathroughShippingId} from '../../../../../services/B2BModule/GetDataAPI';
import {getHubList} from '../../../../../services/B2BModule/CommonFuntion';
import {ReasonList} from '../../../../../services/B2BModule/B2BReason';
import {getHubdropdownlist,getZoneList} from '../../../../../services/B2BModule/HubZoneDataAPI';
import {DamageCategory} from '../../../../../services/B2BModule/DamageCategoryList';
import {uploadImages} from '../../../../../services/B2b/services/uploadImages'



export default {
    name: 'AddNTSShipment',
    components: {
        VueElementLoading,
        Multiselect

    },
    data() {
        return {
            awbnumber: '',
            token: '',
            HubName:'',
            description:'',
            show: false,
            submitDisable: true,
            ReasonList: [],
            hubdata:[],
            alldata: [],
            hubNameList:[],
            token: '',
            imagesarr: [],
            attachment: null,
            displaytable: false,
            newhubs: '',
            Reason: '',
            Damagezone: '',
            image: '',
            showupload: true,
            statuss: '',
            path: `${awsBucketName}/1234/wallpaperflare.com_wallpaper-1.jpg`,
            imgdata: '',
            showModal: false,
            FileSelected: null,
            HubZoneData:[],
            Statusvalue:'',
            damageType:'',
            showCategory:false,
            DamageCategory:'',
            DamageCategorylist:[],
            bagno:0,
            img : '',
            images: []
        }
    },
    mounted() {
        var userToken = window.localStorage.getItem('accessuserToken');
        this.token = userToken.replace(/"/g, '');
        this.username = window.localStorage.getItem('username');
        this.getzonehubs()
        this.Reasondata()
        this.DamageCategorylist=DamageCategory()
    },
    methods: {
    
        Backinvestigation() {
            this.$router.push({ path: '/OperationExecutiveSearchPage' });

          },

          getzonehubs() {
            getZoneList(this.token).then(result => {
              result.data.data.forEach((hub) => {
                this.HubZoneData.push({
                  id: hub.hubzoneid,
                  label: hub.hubzonename
                })
              })
            })
          },
          callHub(newhublist) {
            console.log(newhublist);
            this.hubdata=getHubList(newhublist.id)
          },
          Reasondata()
          {
            ReasonList(this.token).then(Reason=>{
                let ListAll=Reason.data.data
                ListAll.forEach((status) => {
                    this.ReasonList.push({
                    id: status.stdreasonsid,
                    label: status.stdreason,
                  })
                });
            })
          },
          getData(){
            if (!this.awbnumber) return this.$alertify.error("Please Enter ShippingId ");

            let input = {
                ShippingID: this.awbnumber
            }

            getDatathroughShippingId(input, this.token)
            .then(result => {
                if (result.data.code == 200) {
                  let hubNameList = JSON.parse(localStorage.getItem('hubList'));
                    let hubZoneByHubId = JSON.parse(localStorage.getItem('hubzoneByHubId'));
                    let hubZoneList = JSON.parse(localStorage.getItem('hubzoneList'));
                    this.alldata = result.data.data;
                    this.alldata.ShippingID = this.awbnumber;
                    this.alldata.ZoneID = hubZoneByHubId[this.alldata.currenthubid];
                    this.alldata.ZoneName = hubZoneList[this.alldata.ZoneID];
                    this.alldata.currentHubName = hubNameList[this.alldata.currenthubid];
                    this.alldata.originHubName = hubNameList[this.alldata.originhubid];                    this.currentHubName=this.alldata.Getallhubzone
                    this.submitDisable = false;
                }
                else {
                    this.$alertify.error(result.data.message)
                }
            })
        },
        selectData() {
            if(this.damageType=="2"){
              this.showCategory=true
            }
            else{
                this.showCategory=false
            }
          },
        InsertData() {
            let cid = this.alldata.clientid
            let parrentAWB=this.alldata.parentawbno
            let NetValue=this.alldata.netpayment
            let productinformation=this.alldata.productinformation
            let phyweight=this.alldata.packagedetails.Weight.PhyWeight
            let Volweight=this.alldata.packagedetails.Weight.VolWeight
            let DamageReason=this.Reason.id
            let Statusvalue;
            let bucketcodetype;
            if(this.damageType=="1" || this.DamageCategory.id== "1" || this.DamageCategory.id== "3" ){
                Statusvalue=5
                bucketcodetype=1
            }
            else{
                Statusvalue=1
                bucketcodetype=2
            }
            if (!this.description) {
              this.$alertify.error("Please Fill Description")
            }
            else if(!this.damageType) {
                this.$alertify.error("Please Fill DamageType")
              }
              else if(this.damageType=='2' && !this.DamageCategory.id) {
                this.$alertify.error("Please Fill DamageCategory")
              }
              else if(!this.HubName) {
                this.$alertify.error("Please Fill DamageHUB")
              }
              else if (this.attachment == null) {
                this.$alertify.error("Please Upload Images ");
        
              }
              else if(this.images.length <= 4){
                this.$alertify.error("Maximum 5 images can be upload");
              }
              else if(!this.Damagezone) {
                this.$alertify.error("Please Fill DamageZone")
              }
              else if(!this.Reason) {
                this.$alertify.error("Please Fill Reason")
              }
            else {      
              this.input = ({
                shippingid: this.awbnumber,
                buckettypecode:bucketcodetype.toString(),
                currentHub:this.alldata.currenthubid,
                originHub:this.alldata.originhubid,
                currentRegion:this.alldata.ZoneID,
                damageType:this.damageType,
                damagereason:DamageReason.toString(),
                damageHub:this.HubName.id,
                damagezone:this.Damagezone.id,
                damagecategory:this.DamageCategory.id?this.DamageCategory.id:' ',
                netvalue:NetValue?NetValue:0,
                bagno:this.bagno,
                phyweight: phyweight,
                volweight: Volweight,
                status: Statusvalue,
                finaldestinationid:this.alldata.finaldestinationhubid,
                description: this.description,
                contents:productinformation?productinformation:' ',
                parentawbnumber:parrentAWB.toString(),
                clientid: cid.toString(),
                createdby: this.username,
                hubzonename:this.Damagezone.label
              });
              this.uploadImageQueue(this.awbnumber);

              axios({
                method: 'post',
                url: apiUrl.api_url + 'insertInInvestigate',
                data: this.input,
                headers: {
                  'Authorization': 'Bearer ' + this.token
                }
              }).then(result => {  
                if (result.data.status == true) {
                  this.uploadImageQueue(this.awbnumber);
                  this.$alertify.success(result.data.message)
                  this.$router.push({ path: '/OperationExecutiveSearchPage' });
                }
                else {
                  this.$alertify.error(result.data.message)
                }
              })
              this.resetForm();
            }//else
          },
    
        resetForm() {
            this.alldata = {};
            this.HubName = this.Damagezone = this.damageType = this.description=this.Reason = this.awbnumber = '';
            
            this.$validator.reset(); this.errors.clear();
        },
        showImage(filePath) {
            this.img = filePath;
            this.showModal = true;
          },
        onFileChange(event) {
          if(this.images.length > 4){
            this.$alertify.error("Maximum 5 images can be upload");
          }
          else{
            this.attachment = event.target.files[0]; 

            const fr = new FileReader();
              fr.onload = () => {
                this.images.push({attachment : this.attachment, url: fr.result});
              };
              fr.readAsDataURL(this.attachment);     
                 
            this.FileSelected = this.attachment;
            this.FileSelected = null;
          }
        },
        deleteImage(imageIndex){
            if (imageIndex > -1) {
                this.images.splice(imageIndex, 1);
            }
        },
        uploadImageQueue(shippingId){
            this.images.forEach(ele => {
                let form = new FormData();
                form.append('file', ele.attachment);
                form.append('shippingid', shippingId);
                uploadImages(form);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/B2B/OperatonExcutve/AddCargoShipment/AddCargoShipment.component.js